import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const onliveScript = (onliveId) => {
    return `
        (function (o, n, l, i, v, e) {   
            v = o.createElement(n);
            v.onload = i;
            v.async = 1;
            v.src = l;   
            e = o.getElementsByTagName(n)[0];
            e.parentNode.insertBefore(v, e);  
        })(document, 'script', 'https://cdn.onlive.site/loader/v1/loader.min.js', 
        function () {  
            window.onliveManager.loader.load("${onliveId}");   
        });
    `
}

export const useGetOnlive = () => {
    const {customParams} = getConfig() || {}
    const {onliveId} = customParams || ''

    useEffect(() => {
        if (!onliveId) return
        const script1 = document.createElement('script')
        script1.setAttribute('data-testid', 'onlive-script')
        script1.textContent = onliveScript(onliveId)
        document.body.appendChild(script1)
    }, [onliveId])
}
